import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Spots = Record<string, Spot> | null;

export interface Spot {
  buyRemainingDailyLimitAmount: string;
  sellRemainingDailyLimitAmount: string;
  takerFeeRate: string;
}

export const spotsAtom = atom<Spots>(null);

export const subscribeSpotsBunja = createTableAccumulatorBunja(
  'private/spots',
  (store) => (wsData) => store.set(spotsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
